
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 370 280"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#c60c30","d":"M0 0h370v280H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M120 0h40v280h-40z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 120h370v40H0z"}})])
          )
        }
      }
    